import { render, staticRenderFns } from "./top-left.vue?vue&type=template&id=c340581a&scoped=true&"
import script from "./top-left.vue?vue&type=script&lang=js&"
export * from "./top-left.vue?vue&type=script&lang=js&"
import style0 from "./top-left.vue?vue&type=style&index=0&id=c340581a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c340581a",
  null
  
)

export default component.exports